export enum EAttachmentsFileName {
  ALLEGATO2 = 'allegato2',
  ALLEGATO3 = 'allegato3',
  ALLEGATO3A = 'allegato3a',
  ALLEGATO6 = 'allegato6',
}

export const eAttachmentFileName = Object.values(EAttachmentsFileName);
